import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import newCarDemandsServices from '@src/services/newCarDemands/newCarDemands.services';

export const getNewVehicleRequestList = createAsyncThunk(
  'getNewVehicleRequestList',
  async (body, { getState, rejectWithValue }) => {
    try {
      const { pageNumber = 1, pageSize = 10, customerId = null, filter = null } = body;
      const res = await newCarDemandsServices.getNewVehicleRequestList({
        pageNumber,
        pageSize,
        customerId,
        filter,
      });
      return res;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const sendSmsDriver = createAsyncThunk(
  'sendSmsDriver',
  async (body, { getState, rejectWithValue }) => {
    try {
      const { plate, providerType } = body;
      const res = await newCarDemandsServices.sendSmsDriver({
        plate,
        providerType,
      });
      return res;
    } catch (error) {
      console.log('error', error);
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  newCarDemands: [],
  statusList: [],
  orderOwnerList: [],
  deviceTypeList: [],
  providerList: [],
  loading: {
    newCarDemands: false,
  },
  pagedProperty: {
    pageSize: 0,
    totalItems: 0,
    currentPage: 1,
  },
};

export const newCarDemandsSlice = createSlice({
  name: 'newCarDemands',
  initialState,
  reducers: {
    resetCurrentLoadVehicleManagement: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNewVehicleRequestList.pending, (state) => {
        state.loading.newCarDemands = true;
      })
      .addCase(getNewVehicleRequestList.fulfilled, (state, action) => {
        state.loading.newCarDemands = false;
        state.orderOwnerList = action?.payload?.data?.orderOwnerList || [];
        state.deviceTypeList = action?.payload?.data?.deviceTypeList || [];
        state.providerList = action?.payload?.data?.providerList || [];
        state.statusList = action?.payload?.data?.statusList || [];
        state.newCarDemands = action?.payload?.data?.newVehicleRequestResponseItemList || [];
        state.pagedProperty.pageSize = action?.payload?.pageSize || 0;
        state.pagedProperty.totalItems = action?.payload?.totalItems || 0;
        state.pagedProperty.currentPage = action?.payload?.currentPage || 1;
      })
      .addCase(getNewVehicleRequestList.rejected, (state, action) => {
        state.loading.newCarDemands = false;
        state.newCarDemands = [];
        state.orderOwnerList = [];
        state.deviceTypeList = [];
        state.providerList = [];
        state.statusList = [];
        state.pagedProperty = {
          pageSize: 0,
          totalItems: 0,
          currentPage: 1,
        };
        state.error = action.payload || 'Error';
      });
  },
});

export const { resetCurrentLoadVehicleManagement } = newCarDemandsSlice.actions;
